import classes from "./ProgressBar.module.css";
import { useSelector } from "react-redux";
import { selectFormType } from "../../slices/form";
import { useRef, useEffect } from 'react';

const DEFAULT_STEPS = ["select tool", "enter criteria", "create", "export"];
const QUIZ_FLOW_STEPS = [
  "select tool",
  "enter criteria",
  "create questions",
  "export",
];
const COMPREHENSION_FLOW_STEPS = [
  "select tool",
  "enter criteria",
  "create passage",
  "create questions",
  "export",
];
const GRADING_FLOW_STEPS = [
  "select tool",
  "writing assignment",
  "rubric",
  "sample work",
  "student work",
  "rubric grades",
  "edit/export",
];
const SIPPS_FLOW_STEPS = [
  "select tool",
  "enter criteria",
  "review content",
  "download",
];
const TEXT_LEVELING_FLOW_STEPS = [
  "select tool",
  "enter text",
  "adjust",
  "export",
];

const STEPS = {
  reading: COMPREHENSION_FLOW_STEPS,
  assessment: QUIZ_FLOW_STEPS,
  grading: GRADING_FLOW_STEPS,
  sipps: SIPPS_FLOW_STEPS,
  textLeveling: TEXT_LEVELING_FLOW_STEPS,
};

const progessBarStyles = (progess, threshold) => {
  const isProgressReached = progess >= threshold;
  return {
    backgroundColor: isProgressReached ? 'var(--color-primary)' : 'var(--color-surface)',
    border: isProgressReached
      ? '2px solid var(--color-primary)'
      : '2px solid var(--color-border)',
    color: isProgressReached ? 'var(--color-text-inverse)' : 'var(--color-text)'
  };
};

function ProgressBarWithCircles({ progress }) {
  const formType = useSelector(selectFormType);
  const isAssessment = (formType === "assessment" || formType === "sipps");
  const PROGRESS_STEPS = STEPS[formType] || DEFAULT_STEPS;
  const isGrading = formType === "grading";

  const multiplyer = isGrading ? 16 : 25;

  const progressWrapperRef = useRef(null);

  let localProgress = progress;
  if (isAssessment) {
    if (progress === 25) {
      localProgress = 33;
    } else if (progress === 75) {
      localProgress = 66;
    }
  }

  useEffect(() => {
    const calculateWidths = () => {
      if (progressWrapperRef.current) {
        const containerWidth = progressWrapperRef.current.offsetWidth;
        const textWidth = (containerWidth / PROGRESS_STEPS.length) - 10;
        const circleTexts = document.querySelectorAll(`.${classes["circle-text"]}`);
        circleTexts.forEach(text => {
          text.style.width = `${textWidth}px`;
        });
      }
    };

    calculateWidths();

    window.addEventListener('resize', calculateWidths);

    return () => {
      window.removeEventListener('resize', calculateWidths);
    };
  }, [PROGRESS_STEPS.length]);

  return (
    <div ref={progressWrapperRef} className={classes["progress-wrapper"]}>
      <div className={classes["progress-container"]}>
        <div
          className={classes["progress-bar"]}
          style={{ width: `${localProgress}%` }}
        ></div>
        <div className={classes["circle-container"]}>
          {PROGRESS_STEPS.map((progressTitle, index) => {
            return (
              <div
                key={index}
                className={classes.circle}
                style={{
                  ...progessBarStyles(localProgress, index * multiplyer),
                  ...(index === 0 ? { left: "-3px" } : {}),
                  ...(index + 1 === PROGRESS_STEPS.length
                    ? { right: "-8px" }
                    : { top: "-1px" }),
                }}
              >
                <div className={classes["circle-text"]}>{progressTitle}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default ProgressBarWithCircles;
